<template>
  <v-card class="elevation-2" style="max-width: 100%;">
    <v-card-title class="pb-2">
      <span style="font-size: 12px;" class="primary--text"
        >Latest Invoices</span
      >
    </v-card-title>

    <v-card-text class="pa-0">
      <v-list three-line dense>
        <template v-for="item in latestInvoicesDashboard">
          <invoiceListItem :invoice="item" :key="item.id" />
        </template>
      </v-list>

      <v-layout
        row
        justify-center
        align-center
        v-if="!latestInvoicesDashboard.length"
        class="pa-4"
      >
        <span class="error--text">
          <v-icon class="error--text" small>warning</v-icon>No invoices found
        </span>
      </v-layout>
    </v-card-text>
    <v-divider v-show="latestInvoicesDashboard.length"></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        v-if="latestInvoicesDashboard.length"
        color="blue"
        flat
        @click="goToInvoices"
      >
        <v-icon size="12" style="position: relative; top: 2px;" class="pr-1"
          >mdi-file-document</v-icon
        >See all invoices
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import currency from "../../../mixins/currency";
import date from "../../../mixins/date";
import accountingFilters from "../../../mixins/accountingFilters";
import PAGINATED_BANK_INVOICES_INDEX from "../../../graphql/bank_invoices/paginated_index.gql";
import invoiceListItem from "../invoices/invoiceListItem";

export default {
  name: "accountingLatestInvoices",
  mixins: [accountingFilters, currency, date],
  components: { invoiceListItem },
  computed: {
    ...mapGetters("commonStore", ["latestInvoicesDashboard", "getNameById"]),
  },
  methods: {
    invoiceIconColor(operation_type) {
      if (operation_type === "credit") return "success white--text";
      else return "error white--text";
    },
    invoiceIcon(operation_type) {
      if (operation_type === "credit") return "mdi-bank-plus";
      else return "mdi-bank-minus";
    },
    goToInvoices() {
      this.$emit("changeTab", "invoices");
    },
    fetchInvoices() {
      var filter = this.invoicesFilter();
      this.fetchAndSubscribe(
        PAGINATED_BANK_INVOICES_INDEX,
        {
          page: 1,
          per_page: 5,
          order_by: "invoice_date DESC",
          filter: filter,
        },
        "commonStore",
        "latestInvoicesDashboard"
      );
    },
  },
  created() {
    this.fetchInvoices();
  },
  beforeDestroy() {
    this.unsubscribe("latestInvoicesDashboard");
  },
  watch: {
    currencyId() {
      this.fetchInvoices();
    },
    subsidiaryId() {
      this.fetchInvoices();
    },
  },
};
</script>
